export default "__VITE_ASSET__BJSMisFI__"